import get from 'lodash/get'
import map from 'lodash/map'
import find from 'lodash/find'
import { spiritBaseFareAncillaries } from '../FareBrandDrawer/getUpsellOptionsBySlice/getSpiritAncillaries'
import {
  expectedFareBrandShelves,
  fareBrandStatusNames,
  thirdTierKey,
  backupBrandAttributes,
  silverAirlinesAncillaries,
} from '../../constants'

const getTierStatus = (name, expectedName) => {
  if (expectedName === fareBrandStatusNames.notOffered) {
    return fareBrandStatusNames.notOffered
  } else if (!name && expectedName === thirdTierKey) {
    return fareBrandStatusNames.notOffered
  } else if (!name) {
    return fareBrandStatusNames.soldOut
  }
  return fareBrandStatusNames.available
}

const getFareBrandKey = (tierName, airlineCode) =>
  get(expectedFareBrandShelves, [tierName, airlineCode], '').toLowerCase()

const isExpectedCabinName = (brandInfo, tier, airlineCode, flyGaLogic) => {
  try {
    return brandInfo && brandInfo.name.toLowerCase() === tier.expectedName.toLowerCase()
  } catch (e) {
    flyGaLogic.fire.fireGenericListingsEvent('BRANDED FARES SHELF INTERLINE', airlineCode)
    return false
  }
}

const getBrandIds = (itinerary) => {
  const segments = get(itinerary, ['slices', '0', 'segments'], [])
  return map(segments, 'brandId')
}

const updateTierWithBaseFareInfo = (tier, brandInfo, itinerary) => {
  tier.name = brandInfo.name
  tier.brandAttributes = brandInfo.brandAttributes
  tier.price = itinerary.totalPriceWithDecimal.price
  tier.status = fareBrandStatusNames.available
  return tier
}

const getTier = (tierHash, tierName, airlineCode, itinerary, brandReference, flyGalogic) => {
  let tier = tierHash[getFareBrandKey(tierName, airlineCode)] || {}
  const expectedName = get(expectedFareBrandShelves, [tierName, airlineCode])
  tier.status = getTierStatus(tier.name, expectedName)
  tier.expectedName = expectedName
  if (tier.status === fareBrandStatusNames.soldOut) {
    getBrandIds(itinerary).forEach((brandId) => {
      const brandInfo = find(brandReference, ['brandId', brandId])
      if (isExpectedCabinName(brandInfo, tier, airlineCode, flyGalogic)) {
        tier = updateTierWithBaseFareInfo(tier, brandInfo, itinerary)
      }
    })
  }
  return tier
}

const getTierHashKey = (tier, index) => {
  if (index === 2 || tier.tier > 2) {
    return thirdTierKey
  }
  return tier.name.toLowerCase()
}

const getTierHash = (tiers) => {
  const hash = {}
  tiers.forEach((tier, index) => {
    const key = getTierHashKey(tier, index)
    hash[key] = tier
  })
  return hash
}

export function getFareBrandListForBaseAirline(basefare, airlineCode) {
  const isSilverAirlines = airlineCode === silverAirlinesAncillaries.airlineCode
  const airlineAttributes = isSilverAirlines ? silverAirlinesAncillaries : spiritBaseFareAncillaries
  return [
    {
      name: airlineAttributes.name,
      price: basefare,
      status: fareBrandStatusNames.available,
      brandAttributes: airlineAttributes.brandAttributes,
    },
    { status: fareBrandStatusNames.notOffered },
    { status: fareBrandStatusNames.notOffered },
  ]
}

export function getFareBrandList(
  tiers,
  airlineCode,
  itinerary,
  brandReference,
  shelfVariantName,
  flyGalogic
) {
  const tierHash = getTierHash(tiers)
  const tier1 = getTier(tierHash, 1, airlineCode, itinerary, brandReference, flyGalogic)
  const tier2 = getTier(tierHash, 2, airlineCode, itinerary, brandReference, flyGalogic)
  const tier3 = getTier(tierHash, 3, airlineCode, itinerary, brandReference, flyGalogic)
  if (
    shelfVariantName === 'TWOSHELVES' &&
    tier1.status === fareBrandStatusNames.soldOut &&
    tier2.status === fareBrandStatusNames.soldOut &&
    tier3.status === fareBrandStatusNames.available
  ) {
    return [tier1, tier3, tier2]
  }
  return [tier1, tier2, tier3]
}

export function getCompareModalData(fareBrands) {
  const compareDataModal = []
  fareBrands.forEach((fb) => {
    if (fb.status === 'available') {
      compareDataModal.push(fb)
    }
    if (fb.status === fareBrandStatusNames.soldOut && fb.expectedName !== thirdTierKey) {
      compareDataModal.push({
        name: fb.expectedName,
        unavailability: 'Sold Out',
      })
    }
  })
  return compareDataModal
}

export function getStopText(stops) {
  if (stops === 0) {
    return 'Nonstop'
  } else if (stops === 1) {
    return '1 Stop'
  }
  return `${stops} Stops`
}

export function updateFareBrandsWithBackupBrandAttributes(fareBrands, airlineCode) {
  fareBrands.forEach((shelf, index) => {
    const tierNumber = index + 1
    shelf.brandAttributes = [
      {
        type: 'SEATS',
        inclusion: get(backupBrandAttributes, [tierNumber, airlineCode, 'SEATS'], 'NOT_INCLUDED'),
      },
      {
        type: 'CARRY_ON',
        inclusion: get(backupBrandAttributes, [tierNumber, airlineCode, 'CARRY_ON'], 'NOT_INCLUDED'),
      },
      {
        type: 'CHECKED_BAG',
        inclusion: get(backupBrandAttributes, [tierNumber, airlineCode, 'CHECKED_BAG'], 'NOT_INCLUDED'),
      },
    ]
  })
  return fareBrands
}

export function getMissingFareBrandAttributes(fareBrands) {
  const allBrandAttributes = map(fareBrands, 'brandAttributes')
  return !allBrandAttributes.some((ba) => {
    return ba && ba.inclusion !== 'NOT_INCLUDED'
  })
}
